/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'no' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-has-barber"
      progress={76}
      field="hairstyleWomenHasBarber"
      setter="setHairstyleWomenHasBarber"
      ns="hairstyleWomenHasBarber"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
